<template>
    <button
      v-bind:class="{ disabled: loading }"
      class="custom-button"
      :style="{ backgroundColor, borderColor }"
      @click="handleClick"
    >
      <span v-if="srcIcon" class="button-icon">
        <img :src="srcIcon" class="img-fluid"/>
      </span>
      <span v-if="label && !loading" class="button-label" :style="{color}">{{ label }}</span>
      <span v-show="loading" class="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></span>
    </button>
  </template>
  
  <script>
  export default {
    props: {
      label: String,
      backgroundColor: String,
      borderColor: String,
      color: String,
      srcIcon: String,
      loading: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleClick() {
        this.$emit('handleClick')
      },
    },
  };
  </script>
  
  <style scoped>
  .custom-button {
    display: flex;
    padding: 8px 14px;
    justify-content: center;
    align-items: center;
    gap: .5rem;
    border-radius: 8px;
    background: var(--primary-color);
    cursor: pointer;
    border: 1px solid var(--primary-color);;  /* Default border color */
  }
  
  .button-label {
    color: #FCFCFC;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
  
  </style>
  